import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    successText: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Toast message shown when text is successfully copied to the clipboard */
            successText: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCopyText.successText?c=2qe0ipqln2o16", defaultMessage: "Text copied to clipboard" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
